import type { BodyRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ReportPostBody = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  abuse_report: {
    content_object_id: string;
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const reportContentObject = async ({ body }: BodyRequest<ReportPostBody>) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.contentObjects.report, body);
